import React, { ReactElement } from 'react';
import classes from './KNodeItem.module.scss';
import { NodeDef } from '../../config/tileMapConfig';

interface NodeProps {
  node: NodeDef;
  active: boolean;
  nodeStyle?: React.CSSProperties;
}

const KNodeItem = (props: NodeProps): ReactElement => {
  const { active, nodeStyle } = props;
  const finalStyle = nodeStyle || {
    display: 'block'
  };

  // hide nodes on inactive tiles
  if (!active) {
    finalStyle.display = 'none';
  }
  return <div className={classes.node} style={finalStyle} />;
};

export default KNodeItem;
